import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';
import { startsWith } from 'lodash';

const phoneNumberHelper = {
  getCountryCode(phoneNumber) {
    try {
      const asYouType = new AsYouType();
      asYouType.input(phoneNumber);
      return asYouType.getNumber().country;
    } catch (e) {
      return '';
    }
  },
  formatNationalNumber(phoneNumber, countryCode) {
    try {
      const phoneNumberParsed = parsePhoneNumber(phoneNumber.toString(), countryCode);
      return phoneNumberParsed.formatNational();
    } catch (e) {
      return phoneNumber;
    }
  },
  formatInternationalNumber(phoneNumber) {
    try {
      const phoneNumberFormatted = phoneNumber.replaceAll(' ', '');
      if (!startsWith(phoneNumberFormatted, '+', 0) && startsWith(phoneNumberFormatted, '00', 0)) {
        // eslint-disable-next-line no-param-reassign
        phoneNumber = phoneNumber.replace(/\s?0\s?0\s?/, '+');
      }
      const phoneNumberParsed = parsePhoneNumber(phoneNumber.toString());
      return phoneNumberParsed.formatInternational();
    } catch (e) {
      return phoneNumber;
    }
  },
};

export default phoneNumberHelper;
